import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { parseDataSource } from "./expressions.js";
// import { findObjectIdByUsedDataContexts } from "./findObjectIdByUsedDataContexts.js";

var COLORS = ["#336EF4", "#45CAFF", "#41CDCF", "#8146F3", "#F8A075", "#94E65E", "#57689C", "#C285EF", "#FAC60B", "#E4551F", "#8984FF", "#2540FF", "#08BF33", "#F7811C", "#AC7CFF", "#1BA5DC", "#E89716", "#76A6F5", "#4F69FF"];
export default function convertDashboard(_x, _x2, _x3, _x4) {
  return _convertDashboard.apply(this, arguments);
}
function _convertDashboard() {
  _convertDashboard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, mod, state, options) {
    var properties, _ref2, dataSource, _groupField, widgets, groupField, _parseDataSource, isString, expression, chartData, mergedWidgets, metricGroups, mergedMetrics, metricIds, _iterator, _step, _loop, colorCursor, _t;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          properties = _ref.properties;
          _ref2 = properties, dataSource = _ref2.dataSource, _groupField = _ref2.groupField, widgets = _ref2.widgets;
          state.usedHelpers.add("_helper_getLatestMetricValue");
          state.usedHelpers.add("_helper_extractList");
          state.usedHelpers.add("_helper_groupMetricData");
          state.usedHelpers.add("_helper_getMetricDisplayNames");
          groupField = _groupField ? "#showKey" : undefined;
          _parseDataSource = parseDataSource(dataSource), isString = _parseDataSource.isString, expression = _parseDataSource.expression;
          chartData = isString ? "<%= FN._helper_extractList((".concat(expression, ")) %>") : dataSource;
          if (!options.expanded) {
            _context2.next = 9;
            break;
          }
          mergedWidgets = widgets; // const objectId = findObjectIdByUsedDataContexts(
          //   usedContexts,
          //   view.dataSources,
          //   view.variables
          // );
          // const metricGroups = objectId
          //   ? await getPreGeneratedMetricGroups(objectId)
          //   : [];
          metricGroups = [];
          if (!(metricGroups.length > 0)) {
            _context2.next = 8;
            break;
          }
          mergedWidgets = [];
          mergedMetrics = new Set();
          metricIds = new Set(widgets.map(function (w) {
            return w.metric.id;
          }));
          _iterator = _createForOfIteratorHelper(widgets);
          _context2.prev = 1;
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var widget, mergedWidget, group, relevantMetrics, _iterator2, _step2, metricId;
            return _regeneratorRuntime().wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  widget = _step.value;
                  if (!mergedMetrics.has(widget.metric.id)) {
                    _context.next = 1;
                    break;
                  }
                  return _context.abrupt("return", 1);
                case 1:
                  mergedWidget = _objectSpread({}, widget);
                  mergedWidgets.push(mergedWidget);
                  group = metricGroups.find(function (g) {
                    return g.metrics.includes(widget.metric.id);
                  });
                  if (group) {
                    relevantMetrics = group.metrics.filter(function (m) {
                      return metricIds.has(m);
                    });
                    if (relevantMetrics.length > 1) {
                      mergedWidget.relevantMetrics = relevantMetrics;
                      mergedWidget.counterMetric = group.counter;
                      mergedWidget.groupTitle = group.group;
                      _iterator2 = _createForOfIteratorHelper(relevantMetrics);
                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          metricId = _step2.value;
                          mergedMetrics.add(metricId);
                          metricIds["delete"](metricId);
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                    }
                  }
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context2.next = 5;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 3);
        case 3:
          if (!_context2.t0) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("continue", 4);
        case 4:
          _context2.next = 2;
          break;
        case 5:
          _context2.next = 7;
          break;
        case 6:
          _context2.prev = 6;
          _t = _context2["catch"](1);
          _iterator.e(_t);
        case 7:
          _context2.prev = 7;
          _iterator.f();
          return _context2.finish(7);
        case 8:
          colorCursor = 0;
          return _context2.abrupt("return", {
            brick: "div",
            properties: {
              style: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(500px, 1fr))",
                gap: "16px"
              },
              dataset: {
                component: "dashboard"
              }
            },
            children: mergedWidgets.map(function (widget) {
              var _widget$relevantMetri, _widget$relevantMetri2;
              var title = widget.title,
                metric = widget.metric,
                size = widget.size,
                precision = widget.precision;
              var colorCount = (_widget$relevantMetri = (_widget$relevantMetri2 = widget.relevantMetrics) === null || _widget$relevantMetri2 === void 0 ? void 0 : _widget$relevantMetri2.length) !== null && _widget$relevantMetri !== void 0 ? _widget$relevantMetri : groupField ? 2 : 1;
              var colors = Array.from({
                length: colorCount
              }, function (_, i) {
                return COLORS[(colorCursor + i) % COLORS.length];
              });
              colorCursor += colorCount;
              var unit = metric.unit === "load" ? "" : metric.unit;
              var chart = {
                brick: "chart-v2.time-series-chart",
                properties: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                  data: chartData,
                  xField: "time"
                }, widget.relevantMetrics ? {
                  // yFields: widget.relevantMetrics,
                  yFields: "<% FN._helper_getMetricDisplayNames((".concat(expression, ").displayNameList, ").concat(JSON.stringify(widget.relevantMetrics), ") %>")
                } : {
                  // yField: metric.id,
                  yField: "<% FN._helper_getMetricDisplayNames((".concat(expression, ").displayNameList, [").concat(JSON.stringify(metric.id), "])[0] %>")
                }), widget.counterMetric ? {
                  forceAbsoluteNumbers: true,
                  series: _defineProperty({}, widget.counterMetric, {
                    isNegative: true
                  })
                } : null), {}, {
                  height: size === "large" ? 230 : 200,
                  timeFormat: "HH:mm"
                }, widget.relevantMetrics || groupField ? null : {
                  areaOptions: {
                    style: {
                      fill: "l(90) 0:".concat(colors[0], " 1:#ffffff")
                    }
                  }
                }), {}, {
                  axis: {
                    yAxis: _objectSpread(_objectSpread({
                      unit: unit,
                      precision: precision
                    }, widget.counterMetric ? null : unit === "percent(1)" ? {
                      min: 0,
                      max: 1
                    } : unit === "percent(100)" || unit === "%" ? {
                      min: 0,
                      max: 100
                    } : {
                      min: 0
                    }), {}, {
                      shape: "smooth"
                    })
                  },
                  groupField: groupField,
                  areaShape: "smooth",
                  legends: !!(widget.relevantMetrics || groupField),
                  colors: colors,
                  tooltip: {
                    marker: {
                      fill: colors[0],
                      stroke: "#fff",
                      lineWidth: 2,
                      shadowColor: colors[0],
                      shadowBlur: 8,
                      shadowOffsetX: 0,
                      shadowOffsetY: 4
                    },
                    domStyles: {
                      "g2-tooltip": {
                        background: ["radial-gradient( farthest-corner at -20px 150px, ".concat(colors[0], " 0%, rgba(238,238,238,0) 60%)"), "linear-gradient( 180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.8) 100%)"].join(", "),
                        boxShadow: "0px 4px 8px 0px ".concat(convertHexColorToRGBA(colors[0], 0.08)),
                        borderRadius: "8px",
                        border: "1px solid rgba(255,255,255,1)",
                        backdropFilter: "blur(3px)"
                      }
                    }
                  }
                })
              };
              return {
                brick: "div",
                properties: {
                  style: {
                    background: "rgba(255,255,255,0.8)",
                    boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.06)",
                    borderRadius: "8px",
                    padding: "16px 20px 20px"
                  }
                },
                children: [{
                  brick: "div",
                  properties: {
                    style: {
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "20px"
                    },
                    textContent: widget.groupTitle || title || metric.id
                  }
                }, chart]
              };
            })
          });
        case 9:
          if (!groupField) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("return", {
            brick: "div",
            properties: {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "8px"
              }
            },
            children: [{
              brick: ":forEach",
              dataSource: "<%= FN._helper_groupMetricData(FN._helper_extractList((".concat(expression, ")), ").concat(JSON.stringify(groupField), ") %>"),
              children: [{
                brick: "div",
                properties: {
                  textContent: "<% `${ITEM.group}:` %>",
                  style: {
                    fontWeight: "500"
                  }
                }
              }, {
                brick: "div",
                properties: {
                  style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                    marginBottom: "8px"
                  },
                  dataset: {
                    component: "dashboard"
                  }
                },
                children: widgets.map(function (widget, i) {
                  var title = widget.title,
                    metric = widget.metric,
                    precision = widget.precision;
                  return {
                    brick: "ai-portal.stat-with-mini-chart",
                    properties: _objectSpread(_objectSpread({
                      size: "small",
                      label: title || metric.id,
                      data: "<% ITEM.list %>",
                      xField: "time",
                      yField: metric.id,
                      lineColor: COLORS[i % COLORS.length],
                      showArea: true
                    }, metric.unit === "percent(1)" ? {
                      min: 0,
                      max: 1
                    } : metric.unit === "percent(100)" || metric.unit === "%" ? {
                      min: 0,
                      max: 100
                    } : {
                      min: 0
                    }), {}, {
                      value: "<%= FN._helper_getLatestMetricValue(ITEM.list, ".concat(JSON.stringify({
                        metric: metric,
                        precision: precision
                      }), ") %>")
                    })
                  };
                })
              }]
            }]
          });
        case 10:
          return _context2.abrupt("return", {
            brick: "div",
            properties: {
              style: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                gap: "10px"
              },
              dataset: {
                component: "dashboard"
              }
            },
            children: widgets.map(function (widget, i) {
              var title = widget.title,
                metric = widget.metric,
                precision = widget.precision;
              return {
                brick: "ai-portal.stat-with-mini-chart",
                properties: _objectSpread(_objectSpread({
                  size: "small",
                  label: title || metric.id,
                  data: chartData,
                  xField: "time",
                  yField: metric.id,
                  lineColor: COLORS[i % COLORS.length],
                  showArea: true
                }, metric.unit === "percent(1)" ? {
                  min: 0,
                  max: 1
                } : metric.unit === "percent(100)" || metric.unit === "%" ? {
                  min: 0,
                  max: 100
                } : {
                  min: 0
                }), {}, {
                  value: "<%= FN._helper_getLatestMetricValue((".concat(isString ? "FN._helper_extractList((".concat(expression, "))") : JSON.stringify(dataSource !== null && dataSource !== void 0 ? dataSource : null), "), ").concat(JSON.stringify({
                    metric: metric,
                    precision: precision
                  }), ") %>")
                })
              };
            })
          });
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[1, 6, 7, 8]]);
  }));
  return _convertDashboard.apply(this, arguments);
}
function convertHexColorToRGBA(color, alpha) {
  var hex = color.slice(1);
  var bigint = parseInt(hex, 16);
  var r = bigint >> 16 & 255;
  var g = bigint >> 8 & 255;
  var b = bigint & 255;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}
//# sourceMappingURL=convertDashboard.js.map